import { Pipe, PipeTransform } from '@angular/core';
import { ParticipantSummary } from '../../shared/models/orderSearchList';

@Pipe({
  name: 'signingAgentFilter',
  standalone: false
})
export class SigningAgentFilterPipe implements PipeTransform {
  transform(participants: ParticipantSummary[]): ParticipantSummary[] {
    if (!participants) return [];
    return participants.filter(p => p.role === 'SIGNINGAGENT');
  }
}

@Pipe({
  name: 'otherParticipantsFilter',
  standalone: false
})
export class OtherParticipantsFilterPipe implements PipeTransform {
  transform(participants: ParticipantSummary[]): ParticipantSummary[] {
    if (!participants) return [];
    return participants.filter(p => p.role !== 'SIGNINGAGENT');
  }
}

@Pipe({
  name: 'participantNames',
  standalone: false
})
export class ParticipantNamesPipe implements PipeTransform {
  transform(participants: ParticipantSummary[]): string {
    if (!participants || participants.length === 0) return '';
    return participants.map(p => `${p.firstName} ${p.lastName}`).join(', ');
  }
}
